import * as React from 'react';

export const MoveIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke={props.color ?? 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 5v14M9 17l3 3 3-3M15 7l-3-3-3 3M5 12h14M17 15l3-3-3-3M7 9l-3 3 3 3"
    />
  </svg>
);
